import React from 'react';
import { Form, DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/sk_SK';
import { DATETIME_FORMAT_DATE } from '../../../../utils/helpers/CommonHelper';

//https://ant.design/components/date-picker/
const FormRangeDatePicker = ({
  label,
  name,
  rules,
  format = DATETIME_FORMAT_DATE,
  ...rest
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <DatePicker.RangePicker format={format} locale={locale} {...rest} />
    </Form.Item>
  );
};

export default FormRangeDatePicker;
